import axios, { API_URL } from './BaseService';

const ORCA_URL = `${API_URL}/orca/`;

export async function connectWallet(payload) {
    const response = await axios.post(`${ORCA_URL}wallet/connect`, payload);
    return response.data;
}

export async function getWalletPortfolio(walletPublicKey, options = {}) {
    const query = new URLSearchParams();
    if (options.rpcUrl) query.append('rpcUrl', options.rpcUrl);
    if (options.commitment) query.append('commitment', options.commitment);
    if (options.mints?.length) query.append('mints', options.mints.join(','));
    const suffix = query.toString() ? `?${query.toString()}` : '';
    const response = await axios.get(`${ORCA_URL}wallet/${walletPublicKey}/portfolio${suffix}`);
    return response.data;
}

export async function getWalletPositions(walletPublicKey, options = {}) {
    const query = new URLSearchParams();
    if (options.rpcUrl) query.append('rpcUrl', options.rpcUrl);
    if (options.commitment) query.append('commitment', options.commitment);
    const suffix = query.toString() ? `?${query.toString()}` : '';
    const response = await axios.get(`${ORCA_URL}wallet/${walletPublicKey}/positions${suffix}`);
    return response.data;
}

export async function getPool(poolAddress, options = {}) {
    const query = new URLSearchParams();
    if (options.rpcUrl) query.append('rpcUrl', options.rpcUrl);
    if (options.commitment) query.append('commitment', options.commitment);
    const suffix = query.toString() ? `?${query.toString()}` : '';
    const response = await axios.get(`${ORCA_URL}pools/${poolAddress}${suffix}`);
    return response.data;
}

export async function listPools(options = {}) {
    const query = new URLSearchParams();
    if (options.rpcUrl) query.append('rpcUrl', options.rpcUrl);
    if (options.commitment) query.append('commitment', options.commitment);
    if (options.limit) query.append('limit', options.limit);
    if (options.search) query.append('search', options.search);
    if (options.tokensBothOf) query.append('tokensBothOf', options.tokensBothOf);
    if (options.refresh) query.append('refresh', 'true');
    const suffix = query.toString() ? `?${query.toString()}` : '';
    const response = await axios.get(`${ORCA_URL}pools${suffix}`);
    return response.data;
}

export async function getPools(payload) {
    const response = await axios.post(`${ORCA_URL}pools`, payload);
    return response.data;
}

export async function derivePoolAddress(payload) {
    const response = await axios.post(`${ORCA_URL}pools/derive`, payload);
    return response.data;
}

export async function getSwapQuote(payload) {
    const response = await axios.post(`${ORCA_URL}swap/quote`, payload);
    return response.data;
}

export async function doSwap(payload) {
    const response = await axios.post(`${ORCA_URL}swap`, payload);
    return response.data;
}

export async function buildSwapTransaction(payload) {
    const response = await axios.post(`${ORCA_URL}swap/transaction`, payload);
    return response.data;
}

export async function addLiquidity(payload) {
    const response = await axios.post(`${ORCA_URL}liquidity/add`, payload);
    return response.data;
}

export async function getAddLiquidityQuote(payload) {
    const response = await axios.post(`${ORCA_URL}liquidity/add/quote`, payload);
    return response.data;
}

export async function prepareAddLiquidityTransactions(payload) {
    const response = await axios.post(`${ORCA_URL}liquidity/add/prepare`, payload);
    return response.data;
}

export async function buildAddLiquidityTransactions(payload) {
    const response = await axios.post(`${ORCA_URL}liquidity/add/transactions`, payload);
    return response.data;
}

export async function buildRemoveLiquidityTransactions(payload) {
    const response = await axios.post(`${ORCA_URL}liquidity/remove/transactions`, payload);
    return response.data;
}

/** Remonta uma tx do Orca SDK (blockhash novo + assinaturas auxiliares no servidor). */
export async function refreshLiquidityTransaction(payload) {
    const response = await axios.post(`${ORCA_URL}liquidity/transaction/refresh`, payload);
    return response.data;
}

export async function buildPlatformFeeShareTransactions(payload) {
    const response = await axios.post(`${ORCA_URL}liquidity/remove/platform-fee/transactions`, payload);
    return response.data;
}

/** Regista passo do fluxo de liquidez em backend/logs/orca-liquidity.log (página Logs). */
export async function logOrcaLiquidityEvent(payload) {
    await axios.post(`${ORCA_URL}liquidity/log`, payload);
}

export async function removeLiquidity(payload) {
    const response = await axios.post(`${ORCA_URL}liquidity/remove`, payload);
    return response.data;
}

export async function getBots() {
    const response = await axios.get(`${ORCA_URL}bot`);
    return response.data;
}

export async function startBot(payload) {
    const response = await axios.post(`${ORCA_URL}bot/start`, payload);
    return response.data;
}

export async function stopBot(id) {
    const response = await axios.delete(`${ORCA_URL}bot/${id}`);
    return response.data;
}
